const styles = {
  container: {
    position: "relative",
    display: "block",
    width: "100%",
  },
  input: {
    "&::placeholder": {
      color: "rgba(99, 115, 164, 0.5)",
    },
    margin: 0,
    borderWidth: "0px",
    outline: "none",
    boxSizing: "border-box",
    height: "32px",
    borderTopLeftRadius: "4px",
    borderBottomLeftRadius: "4px",
    backgroundColor: "rgba(99, 115, 164, 0.1)",
    color: "#6373A4",
    fontWeight: 300,
    fontFamily: "CircularStd",
    paddingLeft: "10px",
    paddingTop: "7px",
    paddingBottom: "7px",
    paddingRight: "10px",
    caretColor: "#085FE5",
    width: "88%",
    textOverflow: "ellipsis",
  },
  suggestions: {
    boxSizing: "border-box",
    height: "auto",
    maxHeight: "307px",
    overflowY: "scroll",
    width: "206px",
    border: "1px solid rgba(99,115,164,0.2)",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.05)",
    position: "absolute",
    top: "37px",
    fontFamily: "CircularStd",
    fontSize: "12px",
    fontWeight: "300",
    lineHeight: "15px",
    paddingLeft: "6px",
    paddingTop: "7px",
    paddingBottom: "5px",
    paddingRight: "26px",
    cursor: "default",
    zIndex: "10",
    "& div": {
      padding: "0.25rem",
    },
  },
  clearText: {
    cursor: "pointer",
    position: "absolute",
    paddingLeft: "5px",
    right: "18%",
    top: "25%",
  },
  matchedText: {
    color: "#6373A4",
  },
  button: {
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    overflow: "hidden",
    outline: "none",
    display: "block",
    color: "rgba(99, 115, 164, 0.5)",
    fontFamily: "CircularStd",
    fontSize: "12px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "24px",
    margin: 0,
    padding: 0,
    "&:focus": {
      outline: "none",
    },
  },
  suggestionsHoverFocus: {
    width: "100%",
    textAlign: "left",
    "&:focus": {
      backgroundColor: "#6373A4",
      "& > span": {
        "&:nth-of-type(1)": {
          color: "#dcdcdc !important",
        },
        "&:nth-of-type(2)": {
          color: "#fffff0 !important",
        },
        "&:nth-of-type(3)": {
          color: "#dcdcdc !important",
        },
      },
    },
    "&:hover": {
      backgroundColor: "#6373A4",
      "& > span": {
        "&:nth-of-type(1)": {
          color: "#dcdcdc !important",
        },
        "&:nth-of-type(2)": {
          color: "#fffff0 !important",
        },
        "&:nth-of-type(3)": {
          color: "#dcdcdc !important",
        },
      },
    },
  },
  addKeyNavFocus: {
    backgroundColor: "#6373A4",
    "& > span": {
      "&:nth-of-type(1)": {
        color: "#dcdcdc !important",
      },
      "&:nth-of-type(2)": {
        color: "#fffff0 !important",
      },
      "&:nth-of-type(3)": {
        color: "#dcdcdc !important",
      },
    },
  },
  noMatches: {
    color: "rgba(99, 115, 164, 0.5)",
  },
  inputGroup: {
    width: "213px",
    display: "flex",
    alignItems: "center",
  },
  dropDownButton: {
    border: "1px solid rgba(99, 115, 164, 0.1)",
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    background: "#fff",
    display: "inline-block",
    height: "32px",
  },
  caret: {
    transform: "scale(0.8)",
  },
};

export default styles;
